import { CheckCircle, XCircle, Circle } from 'lucide-react';
import {
  DetailCard,
  DetailList,
  DetailRow,
} from '@/client/components/ui/detail-view';
import type { SimulcastTarget } from '@shared/types/events';

interface SimulcastTargetsCardProps {
  targets: SimulcastTarget[];
}

function TransmitStatus({ target }: { target: SimulcastTarget }) {
  if (target.transmissionErrorMsg) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-destructive">
        <XCircle className="h-3 w-3" />
        {target.transmissionErrorMsg}
      </span>
    );
  }
  if (target.transmitting) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-green-500">
        <CheckCircle className="h-3 w-3" />
        Transmitting
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
      <Circle className="h-3 w-3" />
      Idle
    </span>
  );
}

export function SimulcastTargetsCard({ targets }: SimulcastTargetsCardProps) {
  return (
    <DetailCard title={`Simulcast Destinations (${targets.length})`}>
      <DetailList>
        {targets.map((target, i) => (
          <DetailRow
            key={i}
            label={target.providerName}
            value={
              <div className="flex flex-col items-end gap-0.5">
                <span className="text-sm">
                  {target.destName || target.fqdn}
                  <span className="text-muted-foreground ml-1.5 text-xs">
                    ({target.protocol})
                  </span>
                </span>
                <TransmitStatus target={target} />
              </div>
            }
          />
        ))}
      </DetailList>
    </DetailCard>
  );
}
